import {type RestTypeWithTypename} from '../rest-type-with-typename';
import {type UpdateEmployeeResponse} from './contract-base-data';

export function updateEmployeeTypePatcher(data: UpdateEmployeeResponse): RestTypeWithTypename<UpdateEmployeeResponse> {
    return {
        __typename: 'UpdateEmployeeData',
        ...data,
        updateEmployee: {
            __typename: 'UpdateEmployee',
            ...data.updateEmployee,
        },
    };
}
